import React from 'react';
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles} from "../../website-utils/meta";
import ScrollToTopOnMount from "../../website-utils/ScrollToTopOnMount";
import logoBlack from '../../assets/images/logo-black.png';
import moment from 'moment';
import {withStyles} from "@material-ui/core";
import ShiftConfirmForm from "./ShiftConfirmForm";
import {Link} from "react-router-dom";
import routes from "../../routes";


const ShiftPageContent = (props) => {
    const {classes, shift, jobs, business} = props;
    const job = jobs.filter(job => job.id === shift.job)[0];

    // We should probably be using the shift, jobs, and businesses directly and not have a middleman data object
    // But this will do for now
    const data = {
      job_type: job && job.name,
      image: shift.image || business.image,
      business_name: business.name,
      event_name: shift.event,
      date: moment(shift.start_time).format('dddd, D MMM'), // 'Friday, 31 Aug'
      start_time: moment(shift.start_time).format('h:mmA'), // '5:00PM'
      end_time: moment(shift.end_time).format('h:mmA'), // '12:00AM'
      wage: shift.wage,
      required_pros: shift.required_pros,
      address: shift.address || business.address,
      neighborhood: shift.neighborhood || business.neighborhood,
      maps: shift.maps || business.maps,
      attire: shift.attire,
      duties: shift.duties,
      comments: shift.comments,
    };

    window.prerenderReady = true;

    return (
      <div className={classes.shiftPage}>
        <ScrollToTopOnMount/>
        <Helmet>
          {metaTitles(`${data.job_type} for ${data.business_name}`)}
          {metaDescriptions(`${data.job_type} for ${data.business_name} on ${data.date} from ${data.start_time} to ${data.end_time} in ${data.neighborhood}. SGD ${data.wage} per hour.`)}
          {metaImages(`${data.image}`)}
        </Helmet>
        <div className={classes.header}>
          <div className='container'>
            <div className="row justify-content-md-center">
              <div className="col-md-8 col-sm-12">
                <Link to={routes.pros}>
                  <img className="logo" src={logoBlack}/>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className='container'>
            <div className="row justify-content-md-center">
              <div className="col-md-8 col-sm-12">
                <Link to={routes.shiftsPage}>
                  <p>← Back to list</p>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Shift Image */}
        <div id='hero'>
          <div className='container'>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <img src={data.image} className='img-fluid' width='940'/>
              </div>
            </div>
          </div>
        </div>

        {/* Shift Information */}
        <div className='container'>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h1
                className={classes.shiftName}>{`${data.job_type} for ${data.business_name}`}{data.event_name && ` ${data.event_name}`}</h1>
              <p className={classes.shiftDate}>{`${data.date} from ${data.start_time} to ${data.end_time}`}</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-3 col-sm-6'>
              <h3 className={classes.shiftLabel}>Wage</h3>
              <p className={classes.shiftWage}>SGD {`${data.wage}`} per hour</p>
            </div>
            <div className='col-md-3 col-sm-6'>
              <h3 className={classes.shiftLabel}>Job Type</h3>
              <p className={classes.shiftJob}>{`${data.job_type}`}</p>
            </div>
            <div className='col-md-2 col-sm-6'>
              <h3 className={classes.shiftLabel}>Pros Needed</h3>
              <p className={classes.shiftJob}>{`${data.required_pros}`}</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Address</h3>
              <p className={classes.shiftAddress}>
                {data.neighborhood ? (
                  <span>
                    {data.neighborhood} (<a href={data.maps} target="_blank">{data.address}</a>)
                  </span>
                ) : (
                  <span>
                    <a href={data.maps} target="_blank">{data.address}</a>
                  </span>
                )}
              </p>
            </div>
          </div>
          {data.attire &&
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Attire</h3>
              <p>{`${data.attire}`}</p>
            </div>
          </div>}
          {data.duties &&
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Duties</h3>
              <div className={classes.brief} dangerouslySetInnerHTML={{__html: data.duties}}/>
            </div>
          </div>}
          {data.comments &&
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Comments</h3>
              <div className={classes.brief} dangerouslySetInnerHTML={{__html: data.comments}}/>
            </div>
          </div>}
          {business.about && (
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h3 className={classes.shiftLabel}>About {data.business_name}</h3>
                <div dangerouslySetInnerHTML={{__html: business.about}}/>
              </div>
            </div>
          )}
        </div>

        {/* Shift Actions*/}
        <div className={`container ${classes.shiftActions}`}>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <div className={classes.shiftBox}>
                <h3 className={classes.shiftLabel}>Book Shift</h3>
                <ShiftConfirmForm shift={shift}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
;

export default withStyles((theme) => ({
  header: {
    padding: '20px 0',
  },
  shiftPage: {
    marginBottom: '50px',
    '& p': {
      fontSize: '16px',
      lineHeight: '25px',
      marginBottom: '20px'
    },
  },
  shiftSection: {
    borderBottom: '1px solid #ccc',
    marginBottom: '30px',
    paddingBottom: '10px',
  },
  shiftName: {
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '35px',
    marginTop: '15px',
    marginBottom: 0,
    [theme.breakpoints.up('md')]: {
      fontSize: '30px',
      lineHeight: '45px',
    },
  },
  shiftActions: {
    marginTop: '20px',
  },
  shiftLabel: {
    fontSize: '16px',
    lineHeight: '25px',
    fontWeight: 'bold',
    marginBottom: '0',
  },
  shiftBox: {
    border: '1px solid #ccc',
    padding: '15px 10px',
    marginBottom: '20px',
  },
  brief: {
    fontSize: '16px'
  }
}))(ShiftPageContent);



// WEBPACK FOOTER //
// ./src/pages/shift-page/ShiftPageContent.js